import styles from './HeaderV2.module.css'
import { Svg3PointsMore, SvgLogoMetropole } from '../svg/SvgComponents'

import DropdownProfile from '../DropdownProfile/DropdownProfile'
import { Link } from 'react-router-dom'

function HeaderV2() {
  return (
    <header className={styles.navbar_v1}>
      <div className={styles.navbar_v1__grid}>
        <div className={styles.navbar_v1__left}>
          <a href={`/workspaces/`} rel="noopener noreferrer">
            <div className={styles.container_logo}>
              <div className={styles.logo_more}>
                <Svg3PointsMore />
              </div>
              <div className={styles.logo_metropole}>
                <SvgLogoMetropole />
              </div>
            </div>
          </a>
        </div>
        <div className={styles.navbar_v1__center}>
          <div className={styles.logo_name}>forma</div>
        </div>
        <div className={styles.navbar_v1__right}>
          <Link to="/create-form">
            <div className={styles.createButton}>Créer un formulaire</div>
          </Link>

          <div className={styles.profile}>
            <DropdownProfile />
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeaderV2
